import { SIMPANAN_BERJANGKA } from "../../constants/admin/masterdata/constants";

const initialState = {
  cache: {},
  queryKey: null,
  selectedIds: [],
  isModalAction: false,
  loadingGetSimpananBerjangka: true,
  loadingActionSimpananBerjangka: false,
  dataSimpananBerjangka: { count: 0, data: [] },
};

export const simpananBerjangkaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIMPANAN_BERJANGKA.GET_DATA_SIMPANAN_BERJANGKA_SUCCESS:
      return {
        ...state,
        dataSimpananBerjangka: action.data,
      };

    case SIMPANAN_BERJANGKA.LOADING_DATA_SIMPANAN_BERJANGKA_SUCCESS:
      return {
        ...state,
        loadingGetSimpananBerjangka: action.load,
      };

    case SIMPANAN_BERJANGKA.LOADING_ACTION_SIMPANAN_BERJANGKA:
      return {
        ...state,
        loadingActionSimpananBerjangka: action.load,
      };

    case SIMPANAN_BERJANGKA.IS_MODAL_ACTION_SIMPANAN_BERJANGKA:
      return {
        ...state,
        isModalAction: action.load,
      };

    case SIMPANAN_BERJANGKA.SET_QUERY_KEY: {
      if (state.queryKey !== action.key) {
        return { ...state, queryKey: action.key, selectedIds: [] };
      }
      return state;
    }

    case SIMPANAN_BERJANGKA.ADD_SELECTED_IDS: {
      const set = new Set(state.selectedIds);
      (action.ids || []).forEach((id) => set.add(id));
      return { ...state, selectedIds: Array.from(set) };
    }

    case SIMPANAN_BERJANGKA.REMOVE_SELECTED_IDS: {
      const removeSet = new Set(action.ids || []);
      const next = state.selectedIds.filter((id) => !removeSet.has(id));
      return { ...state, selectedIds: next };
    }

    case SIMPANAN_BERJANGKA.CLEAR_SELECTED_IDS:
      return { ...state, selectedIds: [] };

    case SIMPANAN_BERJANGKA.SET_CACHE_ENTRY: {
      const { key, data } = action;
      return {
        ...state,
        cache: {
          ...state.cache,
          [key]: { data, fetchedAt: Date.now(), loading: false },
        },
        dataSimpananBerjangka: data,
        loadingGetSimpananBerjangka: false,
      };
    }

    case SIMPANAN_BERJANGKA.SET_LOADING_FOR_KEY: {
      const { key, loading } = action;
      const prev = state.cache[key] || {};
      return {
        ...state,
        cache: { ...state.cache, [key]: { ...prev, loading } },
        loadingGetSimpananBerjangka: loading,
      };
    }

    case SIMPANAN_BERJANGKA.UPDATE_CACHE_ITEMS: {
      const { changesById } = action; 
      const nextCache = {};
      for (const k in state.cache) {
        const entry = state.cache[k];
        if (!entry?.data?.data) {
          nextCache[k] = entry;
          continue;
        }
        const newList = entry.data.data.map((row) =>
          changesById[row.id] ? { ...row, ...changesById[row.id] } : row
        );
        nextCache[k] = {
          ...entry,
          data: { ...entry.data, data: newList },
        };
      }
      const activeList = state.dataSimpananBerjangka?.data || [];
      const newActive = activeList.map((row) =>
        changesById[row.id] ? { ...row, ...changesById[row.id] } : row
      );
      return {
        ...state,
        cache: nextCache,
        dataSimpananBerjangka: {
          ...state.dataSimpananBerjangka,
          data: newActive,
        },
      };
    }

    default:
      return state;
  }
};
